import { mountHub } from './core/hub';
import { mountHubAdulto } from './core/hub-adulto';
import { router } from './core/router';
import { activities } from './activities/registry';
import { accessibility } from './core/accessibility';
import { isEmbed } from './core/embed';
import { ponte } from 'es-jogos';

const root = document.getElementById('app');
if (!root) {
  throw new Error('Elemento #app não encontrado no index.html.');
}

// Modo embed ANTES do router: a classe precisa existir no primeiro paint,
// e o autoResize já observa o mount inicial da atividade.
if (isEmbed) {
  document.body.classList.add('is-embed');
  ponte.autoResize();
  ponte.pronto('atividades');
}

router.init({
  root,
  activities,
  renderHub: (el) => mountHub(el, activities),
  renderHubAdulto: (el) => mountHubAdulto(el, activities),
});

accessibility.init();
